import axios from 'axios'
// export const webUrl = 'http://localhost:8080'
export const webUrl = 'https://ewak.co.ke'
// export const host = 'http://localhost:8000'
export const host = 'https://portal.ewak.co.ke'

export const base = host + '/'
export const apiUrl = `${host}/api/v1`
export const token = localStorage.getItem('token');

export const clientUrl = '#'
export const http = axios.create({
  timeout: 60 * 4 * 1000,
  /*headers: {
    'x-access-token': token,
    'Access-Control-Allow-Origin': '*',
    'X-Custom-Header': 'foobar'
  }*/
});





